<template>
    <!-- 安安的头 -->
    <div class="annTab">
        <router-link class='annTabLi' :class="{ 'avtive': type=='0'}" :to="{path:'/annOnLine'}">智能客服</router-link>
        <router-link class='annTabLi' :class="{ 'avtive': type=='1'}" :to="{path:'/commonProblem'}">常见问题</router-link>
        <!-- <router-link class='annTabLi' :class="{ 'avtive': type=='2'}" :to="{path:'/fullTextApplication'}">全文申请</router-link> -->
        <router-link class='annTabLi' :class="{ 'avtive': type=='3'}" :to="{path:'/myMessage'}">我的留言</router-link>
        <router-view/>
    </div>
</template>
<script>
export default {
    props: ['type'],
    data(){
        return{
            // xzFlag:'0'
        }
    },
}
</script>
<style lang="less">
.annTab{
    background-color: #0689e7;
    color: #ffffff;
    height: 3.5rem;
    border-bottom: .5rem solid #f5f5f5;
    position: fixed;
    top: 53px;
    width: 100%;
    .annTabLi{
        width: 33.33%;
        float: left;
        text-align: center;
        line-height: 2rem;
        padding-top: .8rem;;
        color: #ffffff;
    }
    .avtive::after{
        content: '';
        display: block;
        height: 0.16rem;
        background-color: #ffffff;
        width: 30%;
        position: relative;
        left: 2.8rem;
    }
}
</style>